/**
 * This file extend the feature of the Data Object
 * This file required "sprintf" module (supposedly defined in cb.common)
 * @author: lanwei su
 */

(function () {
    if (typeof(sprintf) == 'undefined') {
        alert("cb.date requires sprintf module");
        return;
    }

if (!Date.prototype.addSeconds) {
    Date.prototype.addSeconds = function(v) {
        return new Date(this.valueOf() + (v * 1000));
    };
}
if (!Date.prototype.diffSeconds) {
    Date.prototype.diffSeconds = function(v) {
        return parseInt((this - v)/1000);
    };
}

if (!Date.prototype.addMinutes) {
    Date.prototype.addMinutes = function(v) {
        return new Date(this.valueOf() + (v * 60 * 1000));
    };
}
if (!Date.prototype.diffMinutes) {
    Date.prototype.diffMinutes = function(v) {
        return parseInt((this - v)/(60*1000));
    };
}

if (!Date.prototype.addHours) {
    Date.prototype.addHours = function(v) {
        return new Date(this.valueOf() + (v * 60 * 60 * 1000));
    };
}
if (!Date.prototype.diffHours) {
    Date.prototype.diffHours = function(v) {
        return parseInt((this - v)/(60*60*1000));
    };
}

if (!Date.prototype.addDays) {
    Date.prototype.addDays = function(v) {
        return new Date(this.valueOf() + (v * 24 * 60 * 60 * 1000));
    };
}
if (!Date.prototype.diffDays) {
    Date.prototype.diffDays = function(v) {
        return parseInt((this - v)/(24*60*60*1000));
    };
}

if (!Date.prototype.DTGFormat) {
    Date.prototype.DTGFormat = '%Y%m%d%H%M';
}
if (!Date.setDTGFormat) {
    Date.setDTGFormat = function(format) {
        Date.prototype.DTGFormat = format;
        return this;
    };
}
if (!Date.prototype.RegularFormat) {
    Date.prototype.RegularFormat = '%Y-%m-%d %H:%M';
}
if (!Date.setRegularFormat) {
    Date.setRegularFormat = function(format) {
        Date.prototype.RegularFormat = format;
        return this;
    };
}

/**
 * set a private datetime string format for it self
 */
if (!Date.prototype.setFormat) {
    Date.prototype.setFormat = function(format) {
        this.selfFormat = format;
        return this;
    };
}

if (!Date.prototype.strftime) {
    Date.prototype.strftime = function(format) {
        if (!format) {
            if (!this.selfFormat) {
                format = this.RegularFormat;
            }
            else {
                format = this.selfFormat;
            }
        }
        var dayNames = ["日", "一", "二", "三", "四", "五", "六"];

        format = format.replace('%Y', sprintf('%d', this.getFullYear()));
        format = format.replace('%m', sprintf('%02d', this.getMonth()+1));
        format = format.replace('%d', sprintf('%02d', this.getDate()));
        format = format.replace('%-a', sprintf('%s', dayNames[this.getDay()]));
        format = format.replace('%H', sprintf('%02d', this.getHours()));
        format = format.replace('%M', sprintf('%02d', this.getMinutes()));
        format = format.replace('%S', sprintf('%02d', this.getSeconds()));
        return format;
    };
}
if (!Date.prototype.strftimez) {
    Date.prototype.strftimez = function(format) {
        if (!format) {
            if (!this.selfFormat) {
                format = this.RegularFormat;
            }
            else {
                format = this.selfFormat;
            }
        }

        var utc = this.addMinutes(this.getTimezoneOffset());

        format = format.replace('%Y', sprintf('%d', utc.getFullYear()));
        format = format.replace('%m', sprintf('%02d', utc.getMonth()+1));
        format = format.replace('%d', sprintf('%02d', utc.getDate()));
        format = format.replace('%H', sprintf('%02d', utc.getHours()));
        format = format.replace('%M', sprintf('%02d', utc.getMinutes()));
        format = format.replace('%S', sprintf('%02d', utc.getSeconds()));
        return format;
    };
}
if (!Date.prototype.dtgftime) {
    Date.prototype.dtgftime = function() {
        return this.strftime(this.DTGFormat);
    };
}

if (!Date.strptime) {
    /**
     * Parse String to Date
     * @param date_str
     * @param format: if undefined, using default RegularFormat (Use setFormat to set RegularFormat)
     * @return: Date object or null if given string if not a valid date format
     */
    Date.strptime = function(date_str, format) {
        if (!format) {
            format = Date.prototype.RegularFormat;
        }

        var _reg_comp = {
            year: format.indexOf('%Y'),
            month: format.indexOf('%m'),
            day: format.indexOf('%d'),
            hour: format.indexOf('%H'),
            minute: format.indexOf('%M'),
            second: format.indexOf('%S')
        };

        var _reg_idx = {
            year: -1,
            month: -1,
            day: -1,
            hour: -1,
            minute: -1,
            second: -1
        };

        for (var _key in _reg_idx) {
            var _idx = _reg_comp[_key];
            if (_idx == 0) {
                _reg_idx[_key] = _idx;
            }
            else if (_idx > 0) {
                var _sorted_idx = 0;
                for (var _i in _reg_comp) {
                    if (_i == _key) {continue;}
                    if (_reg_comp[_i]>=0 && _reg_comp[_i] < _idx) {
                        _sorted_idx ++;
                    }
                }
                _reg_idx[_key] = _sorted_idx;
            }
        }

        format = format.replace('%Y', "(\\d{4})");
        format = format.replace('%m', "(\\d{2})");
        format = format.replace('%d', "(\\d{2})");
        format = format.replace('%H', "(\\d{2})");
        format = format.replace('%M', "(\\d{2})");
        format = format.replace('%S', "(\\d{2})");

        var _reg = new RegExp(format),
            _rs = date_str.match(_reg);

        if (_rs) {
            try {
                var new_dt = new Date();

                if (_reg_idx.year >= 0) {
                    new_dt.setFullYear(_rs[_reg_idx.year+1]);
                }

                if (_reg_idx.month >= 0) {
                    if (_reg_idx.day >= 0) {
                        new_dt.setMonth(_rs[_reg_idx.month+1] - 1,
                                        _rs[_reg_idx.day+1]);
                    }
                    else {
                        //
                        // set day as first
                        //
                        new_dt.setMonth(_rs[_reg_idx.month+1] - 1, 1);
                    }
                }
                else if (_reg_idx.day >= 0) {
                    new_dt.setDate(_rs[_reg_idx.day+1]);
                }

                if (_reg_idx.hour >= 0) {
                    new_dt.setHours(_rs[_reg_idx.hour+1]);
                }
                else {
                    new_dt.setHours(0);
                }

                if (_reg_idx.minute >= 0) {
                    new_dt.setMinutes(_rs[_reg_idx.minute+1]);
                }
                else {
                    new_dt.setMinutes(0);
                }

                if (_reg_idx.second >= 0) {
                    new_dt.setSeconds(_rs[_reg_idx.second+1]);
                }
                else {
                    new_dt.setSeconds(0);
                }

                new_dt.setMilliseconds(0);

                return new_dt;
            }
            catch (e) { return null; }
        }
        return null;
    };
}
if (!Date.dtgptime) {
    Date.dtgptime = function(dtg_str) {
        return Date.strptime(dtg_str, Date.prototype.DTGFormat);
    };
}

if (!Date.createDateAsUTC) {
    Date.createDateAsUTC = function (date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
                                 date.getHours(), date.getMinutes(), date.getSeconds()));
    }
}
/**
 * we can set a private time zone for it self
 */
if (!Date.prototype.setTimezone) {
    Date.prototype.setTimezone = function(time_zone) {
        /* set time zone in minutes */
        this.selfTimezone = time_zone;
        return this;
    };
}
if (!Date.prototype.getTimezone) {
    Date.prototype.getTimezone = function() {
        /* return time zone in minutes */
        if (typeof(this.selfTimezone) == 'undefined') {
            this.selfTimezone = this.getTimezoneOffset();
        }
        return this.selfTimezone;
    };
}

if (!Date.prototype.toUTC) {
    Date.prototype.toUTC = function() {
        var _tz = this.getTimezone();
        if (_tz == 0) {
            return this;
        }
        else {
            return this.addMinutes(_tz);
        }
    };
}
if (!Date.prototype.toLocal) {
    Date.prototype.toLocal = function() {
        var _tz = this.getTimezone(),
            _dt_z = this.getTimezoneOffset();
        if (_dt_z == _tz) {
            return this;
        }
        else {
            return this.addMinutes(-1 * _dt_z);
        }
    };
}

//
// Returns a string with the date d formatted according to fmt.
// A subset of the Open Group's strftime format is supported.
//
Date.prototype.formatDate  = function (fmt, monthNames, dayNames) {
    var d = this;

    if (typeof d.strftime == "function") {
        return d.strftime(fmt);
    }

    var leftPad = function(n, pad) {
        n = "" + n;
        pad = "" + (pad == null ? "0" : pad);
        return n.length == 1 ? pad + n : n;
    };

    var r = [];
    var escape = false;
    var hours = d.getHours();
    var isAM = hours < 12;

    if (monthNames == null) {
        monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    }

    if (dayNames == null) {
        dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    }

    var hours12;

    if (hours > 12) {
        hours12 = hours - 12;
    } else if (hours == 0) {
        hours12 = 12;
    } else {
        hours12 = hours;
    }

    for (var i = 0; i < fmt.length; ++i) {

        var c = fmt.charAt(i);

        if (escape) {
            switch (c) {
                case 'a': c = "" + dayNames[d.getDay()]; break;
                case 'b': c = "" + monthNames[d.getMonth()]; break;
                case 'd': c = leftPad(d.getDate()); break;
                case 'e': c = leftPad(d.getDate(), " "); break;
                case 'H': c = leftPad(hours); break;
                case 'I': c = leftPad(hours12); break;
                case 'l': c = leftPad(hours12, " "); break;
                case 'm': c = leftPad(d.getMonth() + 1); break;
                case 'M': c = leftPad(d.getMinutes()); break;
                // quarters not in Open Group's strftime specification
                case 'q':
                    c = "" + (Math.floor(d.getMonth() / 3) + 1); break;
                case 'S': c = leftPad(d.getSeconds()); break;
                case 'y': c = leftPad(d.getFullYear() % 100); break;
                case 'Y': c = "" + d.getFullYear(); break;
                case 'p': c = (isAM) ? ("" + "上午") : ("" + "下午"); break;
                case 'P': c = (isAM) ? ("" + "AM") : ("" + "PM"); break;
                case 'w': c = "" + d.getDay(); break;
            }
            r.push(c);
            escape = false;
        } else {
            if (c == "%") {
                escape = true;
            } else {
                r.push(c);
            }
        }
    }

    return r.join("");
};

}());



// WEBPACK FOOTER //
// ./src/assets/js/cb.date.js